import React from 'react';
import { ParrotfyLogo } from '../../components';

const DeliveryOrderSuccessForm = () => {
  return (
    <div
      className="containerSpinnerLoad"
      style={{
        position: 'absolute',
        flexDirection: 'column',
        height: '100%',
        width: '98%',
        textAlign: 'center'
      }}
    >
      {/* Legacy Twist-flow view - keep the Twist GO logo at its original size. */}
      <ParrotfyLogo variant="twistgo" style={{ width: '17%', height: 'auto', marginBottom: 20 }} />
      <h3
        style={{
          padding: '30px',
          fontWeight: 'bold',
          margin: '5px 0',
          color: 'rgba(255,136,17,1)'
        }}
      >
        Formulario enviado con éxito
      </h3>
      <p style={{ color: 'rgba(255,136,17,1)' }}> </p>
    </div>
  );
};

export default DeliveryOrderSuccessForm;
